import ListItem from "./components/listItem";
import * as Styled from "./styled";
import moment from "moment";

import exportFromJSON from "export-from-json";
import { functionService } from "../../../../../lib/functions";
import { useEffect, useState } from "react";

import Top from "./components/top";
import styled from "styled-components";
import { useParams } from "react-router-dom";

export function isArray(val) {
  return Object.prototype.toString.call(val) === "[object Array]";
}

export const exportExcel = (data, fileName, exportType) => {
  exportFromJSON({ data, fileName, exportType });
};

export function isNotEmptyArray(val) {
  return isArray(val) && val.length !== 0;
}

const Button = styled.button`
  background: #ffffff;
  mix-blend-mode: normal;
  border: 1px solid #1b49ea;
  border-radius: 6px;
  color: #1b49ea;
  padding: 10px 15px;
  margin-left: 10px;

  
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
`;
const Requests = () => {
  const { recruiter_id, search_id } = useParams();
  const [shortlistedCandidateList, setShortlistedCandidateList] = useState([]);

  const getShortlistedCandiate = async () => {
    const { status, response } = await functionService.get(
      `recruiter/approved-candidates-list/${recruiter_id}/${search_id}`
    );

    if (status) {
      setShortlistedCandidateList(response.data.data.approvedCandidates);
    }
  };

  useEffect(() => {
    getShortlistedCandiate();
  }, []);

  const [selectedListCandidate, setSelectedListCandidate] = useState([]);

  const handleExportClick = () => {
    functionService
      .get(`recruiter/approved-candidates-list/${recruiter_id}/${search_id}`)
      .then(({ status, response }) => {
        if (isNotEmptyArray(response.data.data.approvedCandidates)) {
          const finalResult = response.data.data.approvedCandidates.map(
            (el, elIndex) => {
              return {
                "S.No.": elIndex + 1,
                Name: el.name,
                "E-mail Address": el.email,
                "Mobile No.": el.phoneno || "-",
                "Account Name": el.company_name || "-",
                Designation: el.designation || "-",
                Experience: `${el.experience_year} yr ${el.experience_month} mn`,
                "Current Location": el.location || "-",
                Salary: el.current_salary ? el.current_salary + " LPA" : "-",
                "Key Skills": el.skills?.toString() || "-",
                "College Name": el.college || "-",
              };
            }
          );

          console.log();
          exportExcel(
            finalResult,
            `confirmed_candidate_role_${moment().format("DD-MM-YYYY")}`,
            "csv"
          );
        } else {
          console.log("aa");
        }
      });
  };

  return (
    <Styled.ContainerDiv>
      <Top
        dataToShow={shortlistedCandidateList}
        handleExportClick={handleExportClick}
      />
      {shortlistedCandidateList.map((currentCandidateDetails) => {
        return (
          <ListItem
          profile_image={currentCandidateDetails.profile_image}
            selectedListCandidate={selectedListCandidate}
            setSelectedListCandidate={setSelectedListCandidate}
            location={currentCandidateDetails.location}
            experience_month={currentCandidateDetails.experience_month?currentCandidateDetails.experience_month%12:currentCandidateDetails.experience_month}
            experience_year={currentCandidateDetails.experience_year?Math.floor(currentCandidateDetails.experience_month/12):currentCandidateDetails.experience_year}
            userImage={currentCandidateDetails.experience_year}
          
            skills={currentCandidateDetails.skillsdata.filter(({top_percentile})=>top_percentile)}
            
            studentId={currentCandidateDetails.id}
            candidateID={currentCandidateDetails.id}
            resume={currentCandidateDetails.resume}
            profileName={currentCandidateDetails.name}
            emailId={currentCandidateDetails.email}
            phone={currentCandidateDetails.phone}
            setDataToShow={setShortlistedCandidateList}
            current_state={currentCandidateDetails.current_state}
            getShortlistedCandiate={getShortlistedCandiate}
            offer_accepted={currentCandidateDetails.offer_accepted}
            offer_sent={currentCandidateDetails.offer_sent}
          />
        );
      })}
    </Styled.ContainerDiv>
  );
};
export default Requests;
